import { Stack } from '@mui/material';
import { MprcContainer, MprcRequestErrorReport } from 'components';
import { MprcRibbonTabbed } from 'components/MprcRibbonList';
import { IndicatorCardDto } from 'generated/CoreApi_v1';
import TzUtils from 'lib/TzUtils';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useEffect, useState } from 'react';
import { GeneralIndicatorCardLoading } from 'views/general/Cards/GeneralIndicatorCardLoading';
import { IndicatorDtoToCardRibbon } from 'views/general/Cards/IndicatorDtoToCardRibbon';
import { HomeCarouselProps } from 'views/home';

////////////////////////////////////////////////////////////////////////////////

export const HomeIndicator = (props: HomeCarouselProps) => {
    const api = useCoreApi();
    const [viewError, setViewError] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [indicators, setIndicators] = useState<IndicatorCardDto[]>([]);

    ///
    async function loadIndicators() {

        try {
            const response = await api.v1.indicator.getIndicatorData({ browserTimeZoneId: TzUtils.browserTimezone(), });
            setIndicators(response.data);
            if (response.data.length == 0) props.onEmptyDataset();
        }
        catch (error) {
            setViewError(error);
        }
        finally {
            setLoading(false);
        }
    }


    ///
    useEffect(() => {
        if (loading) loadIndicators();
    }, [loading]);

    if(!loading && indicators.length == 0) return null;

    ///
    return viewError
        ? <MprcRequestErrorReport error={viewError} />
        : (
            <MprcContainer margin="large">
                <MprcRibbonTabbed.Container key={"container-indicator"} >
                    {
                        (maxWidth, gap, margin) => (
                            <Stack direction="row" gap={1} flexWrap="wrap">
                                {
                                    loading
                                        ? <GeneralIndicatorCardLoading />
                                        : IndicatorDtoToCardRibbon(indicators)
                                }
                            </Stack>
                        )
                    }
                </MprcRibbonTabbed.Container>
            </MprcContainer>
        );
};
